module.exports = __webpack_public_path__ + "img/flotilla-noche.547a634c.png";